var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1 col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          return _vm.switchTab(tab)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n          ")])
  }), 0), _vm._v(" "), _c('fieldset', [(_vm.currentTab == 'palletUpload') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Upload File "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('configFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv files allowed to upload.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('configFile')),
      expression: "errors.has('configFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": "Download Bin Config template CSV"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadBinConfigTemplate.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Bin Config Template\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Download Failed Configuration")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download CSV file"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_vm._v("Download CSV\n                        "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "#92969D"
    }
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "card-header",
    staticStyle: {
      "background-color": "#f0f3f5"
    }
  }, [_c('i', {
    staticClass: "fa fa-table barcolor"
  }), _vm._v(" Bin Config List\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bin Number")]), _vm._v(" "), (_vm.binPickerUi.hasSelection) ? _c('div', {
    staticClass: "bin-pallet-selected-box"
  }, [(_vm.binPicker.checkAll) ? _c('span', {
    staticClass: "bin-pallet-selected-box__chip"
  }, [_c('span', [_vm._v(_vm._s(_vm.binPickerUi.summaryLabel))]), _vm._v(" "), _c('i', {
    staticClass: "bin-pallet-selected-box__remove",
    attrs: {
      "aria-hidden": "true",
      "tabindex": "1"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.binPickerReset.apply(null, arguments)
      }
    }
  })]) : [_vm._l((_vm.binPickerUi.displayedChips), function(option, index) {
    return _c('span', {
      key: ((option.value) + "-" + index),
      staticClass: "bin-pallet-selected-box__chip"
    }, [_c('span', [_vm._v(_vm._s(option.text))]), _vm._v(" "), _c('i', {
      staticClass: "bin-pallet-selected-box__remove",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.binPickerRemoveChip(option)
        }
      }
    })])
  }), _vm._v(" "), (_vm.binPickerUi.remainingChips > 0) ? _c('span', {
    staticClass: "bin-pallet-selected-box__chip bin-pallet-selected-box__chip--summary"
  }, [_vm._v("\n                        +" + _vm._s(_vm.binPickerUi.remainingChips) + " more\n                      ")]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bin-pallet-multiselect-wrap"
  }, [_c('multiselect', {
    ref: "binPickerMultiselect",
    attrs: {
      "options": _vm.binPickerUi.dropdownOptions,
      "name": "binFilterNumbers",
      "multiple": true,
      "searchable": true,
      "internal-search": false,
      "hide-selected": false,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "Select Bin Number",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "search-change": _vm.binPickerOnSearchChange,
      "input": _vm.binPickerSyncCheckAll
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;

        return [_c('div', {
          staticClass: "multiselect__tags-wrap bin-pallet-hidden-selected-tags"
        })]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "bin-pallet-option",
          class: {
            'bin-pallet-option--locked': _vm.binPicker.checkAll
          },
          on: {
            "mousedown": function($event) {
              $event.preventDefault();
            },
            "click": function($event) {
              $event.stopPropagation();
              return _vm.binPickerToggleOption(props.option)
            }
          }
        }, [_c('span', {
          staticClass: "bin-pallet-checkbox",
          class: {
            'bin-pallet-checkbox--checked': _vm.binPickerIsSelected(props.option)
          },
          attrs: {
            "aria-hidden": "true"
          }
        }, [_c('span', {
          staticClass: "bin-pallet-checkbox__mark"
        }, [_vm._v("✓")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.option.text))])])]
      }
    }], null, false, 194082532),
    model: {
      value: (_vm.binPicker.selected),
      callback: function($$v) {
        _vm.$set(_vm.binPicker, "selected", $$v)
      },
      expression: "binPicker.selected"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "beforeList"
  }, [_c('div', {
    staticClass: "bin-pallet-select-all",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.binPickerToggleCheckAll.apply(null, arguments)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.binPicker.checkAll
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.binPicker.allLabel))])]), _vm._v(" "), (_vm.binPicker.checkAll) ? _c('div', {
    staticClass: "bin-pallet-dropdown-hint"
  }, [_vm._v("\n                          All items are selected. Clear the selection chip above to pick individual items.\n                        ")]) : (_vm.binPickerUi.dropdownTruncated) ? _c('div', {
    staticClass: "bin-pallet-dropdown-hint"
  }, [_vm._v("\n                          Showing first " + _vm._s(_vm.binPickerUi.dropdownOptions.length) + " of " + _vm._s(_vm.binPickerUi.dropdownTotal) + ". Refine your search to narrow results.\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bin-pallet-search-actions"
  }, [_c('button', {
    staticClass: "bin-pallet-search-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.binPickerUi.searchActionCount === 0
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        return _vm.binPickerBulkSelect(true)
      }
    }
  }, [_vm._v("\n                            Select all from search (" + _vm._s(_vm.binPickerUi.searchActionCount) + ")\n                          ")]), _vm._v(" "), _c('button', {
    staticClass: "bin-pallet-search-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.binPickerUi.hasActiveSearch || _vm.binPickerUi.searchActionCount === 0 || _vm.binPicker.checkAll
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        return _vm.binPickerBulkSelect(false)
      }
    }
  }, [_vm._v("\n                            Deselect all from search (" + _vm._s(_vm.binPickerUi.searchActionCount) + ")\n                          ")])])])], 2)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.binPicker.loading))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Bin Type")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.binPanel.filters.typeOptions,
      "label": "text",
      "track-by": "value",
      "multiple": true,
      "close-on-select": false,
      "placeholder": "All",
      "show-labels": false
    },
    model: {
      value: (_vm.binPanel.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.binPanel.filters, "type", $$v)
      },
      expression: "binPanel.filters.type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Sector")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.binPanel.filters.sectorOptions,
      "label": "text",
      "track-by": "value",
      "multiple": true,
      "close-on-select": false,
      "placeholder": "All",
      "show-labels": false
    },
    model: {
      value: (_vm.binPanel.filters.sector),
      callback: function($$v) {
        _vm.$set(_vm.binPanel.filters, "sector", $$v)
      },
      expression: "binPanel.filters.sector"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Row")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.binPanel.filters.rowOptions,
      "label": "text",
      "track-by": "value",
      "multiple": true,
      "close-on-select": false,
      "placeholder": "All",
      "show-labels": false
    },
    model: {
      value: (_vm.binPanel.filters.row),
      callback: function($$v) {
        _vm.$set(_vm.binPanel.filters, "row", $$v)
      },
      expression: "binPanel.filters.row"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binPanel.filters.status),
      expression: "binPanel.filters.status"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.binPanel.filters, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Inactive")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.applyBinFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetBinFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]), _vm._v(" "), (_vm.binPanel.list.length > 0) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "title": "Download all active bins matching current filters"
    },
    on: {
      "click": _vm.downloadBinConfigList
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    style: (_vm.binPanel.list.length > 8 ? 'overflow: auto; height: 360px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Length")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Breadth")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Height")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Max Vol Wt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Max Phys Wt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Max Pallets")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Wt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Occupancy")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sector")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Row")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.binPanel.list), function(data, index) {
    return (_vm.binPanel.list.length > 0) ? _c('tr', {
      key: data.binid || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.binPanel.pageno * _vm.binPanel.limit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.binnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.bintypeLabel))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.bintype),
        expression: "binPanel.edit.row.bintype"
      }],
      staticClass: "form-control form-control-sm",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.binPanel.edit.row, "bintype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("Rack")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("Floor")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("Pigeon Hole")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.isactive !== false ? 'Active' : 'Inactive'))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.isActive),
        expression: "binPanel.edit.row.isActive"
      }],
      staticClass: "form-control form-control-sm",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.binPanel.edit.row, "isActive", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": true
      }
    }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": false
      }
    }, [_vm._v("Inactive")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.binlength))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.binlength),
        expression: "binPanel.edit.row.binlength"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "any"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.binlength)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "binlength", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.binbreadth))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.binbreadth),
        expression: "binPanel.edit.row.binbreadth"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "any"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.binbreadth)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "binbreadth", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.binheight))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.binheight),
        expression: "binPanel.edit.row.binheight"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "any"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.binheight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "binheight", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.binmaxvolumetriccapacity))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.binmaxvolumetriccapacity),
        expression: "binPanel.edit.row.binmaxvolumetriccapacity"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "any"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.binmaxvolumetriccapacity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "binmaxvolumetriccapacity", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.binmaxphysicalcapacity))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.binmaxphysicalcapacity),
        expression: "binPanel.edit.row.binmaxphysicalcapacity"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "any"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.binmaxphysicalcapacity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "binmaxphysicalcapacity", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.maxnoofpallets))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.maxnoofpallets),
        expression: "binPanel.edit.row.maxnoofpallets"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.maxnoofpallets)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "maxnoofpallets", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.binshipmentweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.occupancy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.sector || '--'))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.sector),
        expression: "binPanel.edit.row.sector"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "text",
        "placeholder": "Sector"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.sector)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "sector", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', [_vm._v(_vm._s(data.row || '--'))]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.binPanel.edit.row.row),
        expression: "binPanel.edit.row.row"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "text",
        "placeholder": "Row"
      },
      domProps: {
        "value": (_vm.binPanel.edit.row.row)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.binPanel.edit.row, "row", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifiedby || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.lastmodifieddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.binPanel.edit.index !== index) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "title": "Edit bin"
      },
      on: {
        "click": function($event) {
          return _vm.editBinRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.binPanel.edit.index === index) ? _c('span', [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "green",
        "margin-right": "8px"
      },
      attrs: {
        "title": "Save"
      },
      on: {
        "click": _vm.saveBinRow
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Cancel"
      },
      on: {
        "click": function($event) {
          return _vm.cancelEditBinRow()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.binPanel.list.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "20"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.binPanel.totalRows > _vm.binPanel.limit),
      expression: "binPanel.totalRows > binPanel.limit"
    }],
    attrs: {
      "page-count": _vm.binPanel.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getBinPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'palletConfig') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onpalletUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("CutOff Config "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('palletConfigFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "palletConfigFile",
      "id": "palletConfigFile"
    },
    on: {
      "change": _vm.clearPalletConfigFileError
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv files allowed to upload.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('palletConfigFile')),
      expression: "errors.has('palletConfigFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": "Download CutOff Config template CSV"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadCutoffTemplate.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" CutOff Config Template\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.palletFailed.length > 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Download Failed Config")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Failed Config"
    },
    on: {
      "click": _vm.exportPalletFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download CSV\n                        "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "#92969D"
    }
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    style: (_vm.isdisableupload ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "submit",
      "disabled": _vm.isdisableupload
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetPalletForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "padding": "0.5rem 1rem"
    }
  }, [_c('i', {
    staticClass: "fa fa-table barcolor"
  }), _vm._v(" CutOff Config List\n              ")]), _vm._v(" "), _c('div', {
    style: (_vm.palletConfigList.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Facility Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LM")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("FM")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MM")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hours")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")]), _vm._v(" "), (!_vm.isdisableupload) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.palletConfigList), function(data, index) {
    return (_vm.palletConfigList.length > 0) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.facilityname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.editIndex !== index) ? _c('span', [_vm._v(_vm._s(data.eligible_lm ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.editIndex === index) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editRow.eligible_lm),
        expression: "editRow.eligible_lm"
      }],
      staticClass: "form-control form-control-sm",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.editRow, "eligible_lm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": true
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": false
      }
    }, [_vm._v("No")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.editIndex !== index) ? _c('span', [_vm._v(_vm._s(data.eligible_fm ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.editIndex === index) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editRow.eligible_fm),
        expression: "editRow.eligible_fm"
      }],
      staticClass: "form-control form-control-sm",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.editRow, "eligible_fm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": true
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": false
      }
    }, [_vm._v("No")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.editIndex !== index) ? _c('span', [_vm._v(_vm._s(data.eligible_mm ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.editIndex === index) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editRow.eligible_mm),
        expression: "editRow.eligible_mm"
      }],
      staticClass: "form-control form-control-sm",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.editRow, "eligible_mm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": true
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": false
      }
    }, [_vm._v("No")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.editIndex !== index) ? _c('span', [_vm._v(_vm._s(data.cutoff_hours))]) : _vm._e(), _vm._v(" "), (_vm.editIndex === index) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editRow.cutoff_hours),
        expression: "editRow.cutoff_hours"
      }],
      staticClass: "form-control form-control-sm",
      staticStyle: {
        "width": "80px",
        "margin": "0 auto"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.editRow, "cutoff_hours", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((24), function(h) {
      return _c('option', {
        key: h,
        domProps: {
          "value": h
        }
      }, [_vm._v(_vm._s(h))])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.type ? data.type : 'MPS'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.lastmodifieddate)))]), _vm._v(" "), (!_vm.isdisableupload) ? _c('td', {
      staticClass: "text-center"
    }, [(_vm.editIndex !== index) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.editPalletRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.editIndex === index) ? _c('span', [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "green",
        "margin-right": "8px"
      },
      on: {
        "click": function($event) {
          return _vm.savePalletRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.cancelEditPalletRow()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]) : _vm._e()]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.palletConfigList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])]) : _vm._e()], 1)], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("Palletization Masters")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92b599aa","hasScoped":true}!./src/views/components/Palletization/Masters/Masters.html
// module id = 1802
// module chunks = 2